import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCodeInsert: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"code-insert"} maskId="square-filled-radius-0-stroke-1-IconCodeInsert"><path d="M15 2H16V4H22V20H16V22H15V2Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H14V20H2ZM7.5 8.79289L6.79289 9.5L9.29289 12L6.79289 14.5L7.5 15.2071L10.7071 12L7.5 8.79289Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCodeInsert;
